import { defineMessages } from 'react-intl';

const messages = defineMessages({
  VatPending: 'VAT pending',
  AuditLog: 'Audit log',
  FilterOnFields: 'Filter on fields',
  LoadFailed: 'The audit log could not be loaded. Change the filter to try again.',
  DateFrom: 'From',
  DateUntil: 'Until',
  Yes: 'Yes',
  No: 'No',
  SetEnum: '{property} was set to {value}',
  ClearEnum: '{property} was cleared. Old value: {value}',
  ChangedField: '{property} was changed from {originalValue} to {currentValue}',
  AddedFieldForCommunication:
    'has added a communication channel of {property} with value {newValue}',
  DeletedFieldForCommunication:
    'has deleted a communication channel of {property} with value {oldValue}',
  ChangedFieldForCommunication:
    'has changed {property} from {originalValue} to {currentValue} for a communication channel',
  AddedLink: 'A {linkType} was added: {relation}',
  RemovedLink: 'A {linkType} was removed: {relation}',
  ForRelationLinkWith: 'for relation link with {relation}',
  ForRelationLinkOfTypeWith: 'for relation link ({linkType}) with {relation}',
  AddedAnUboSnapshotAt: 'An ubo snapshot was added at {time}',
  DeletedAnUboSnapshotAt: 'An ubo snapshot was deleted at {time}',
  UboSnapshotEnteredOnline: 'UBO snapshot of {time} was entered online',
  NoItems: 'No items found',
  Estox: 'eStox',
  Eid: 'eID',
  AuthorizationList: 'Authorization list',
  GenericDocumentRecognition: 'Document recognition',
  AddedCommunicationSetting:
    'has added a communication setting of purpose {property} using medium {medium} with value {newValue}',
  DeletedCommunicationSetting:
    'has deleted a communication setting of purpose {property} using medium {medium} with value {oldValue}',
  ChangedCommunicationSetting:
    'has changed a communication setting of purpose {property} using medium {medium} from {originalValue} to {currentValue}',
  ChangedCommunicationSettingAssignments:
    'has changed the assignments of a communication setting of purpose {property} from <b>{originalValue}</b> to <b>{currentValue}</b>',
  ChangedCommunicationSettingForAddress:
    'has changed a communication setting of purpose {property} using medium {medium} for <b>{address}</b> from {originalValue} to {currentValue}',
  ChangedCommunicationSettingAssignmentsForAddress:
    'has changed the assignments of a communication setting of purpose {property} for <b>{address}</b> from <b>{originalValue}</b> to <b>{currentValue}</b>',
  AllAssignments: 'All assignments',
  DefaultAssignment: 'Default assignment',
  RelationCreated: 'Relation was created',
  AddedAuthorization: 'An authorization with name {name} was created',
  DeletedAuthorization: 'An authorization with name {name} was deleted',
  AuthorizationProperty: ' for an authorization link',
  AuthorizationPropertyWithName: ' for an authorization link with name <b>{name}</b>',
  DeletedBankAccount: 'A bank account with IBAN {iban} was deleted',
  AddedBankAccount: 'A bank account with IBAN {iban} was added',
  BankAccountProperty: ' for a bank account',
  BankAccountWithDisplayValueProperty: ' for a bank account with IBAN <b>{iban}</b>',
  NbbForeingAccountsDocument: 'NBB - foreign accounts',
  AddedAssignment: 'An assignment with name {name} was created',
  DeletedAssignment: 'An assignment with name {name} was deleted',
  DefaultAssignmentProperty: ' for the default assignment',
  AssignmentWithDisplayValueProperty: ' for assignment <b>{name}</b>',
  AddedNaceCode: 'Nace code {code} was added',
  DeletedNaceCode: 'Nace code {code} was deleted',
  NaceCodeProperty: ' for a nace code',
  NaceCodeWithDisplayValueProperty: ' for nace code <b>{code}</b>',
  AddedPlannedRegistration: 'A planned registration {name} was added',
  DeletedPlannedRegistration: 'A planned registration {name} was deleted',
  PlannedRegistrationStartingOn: '{name} starting on {startDate}',
  PlannedRegistrationProperty: ' for a planned registration',
  PlannedRegistrationWithDisplayValueProperty: ' for planned registration <b>{name}</b>',
  PlannedRegistrationSchedule: 'Schedule',
  PlannedRegistrationStartDate: 'Start planning',
  PlannedRegistrationEndDate: 'Planning until',
  PlannedRegistrationDay: 'Day',
  PlannedRegistrationMonth: 'Month',
  PlannedRegistrationResource: 'Resource',
  PlannedRegistrationUser: 'User',
  PlannedRegistrationPriceGrid: 'Price grid',
  PlannedRegistrationInForfait: 'In forfait',
  PlannedRegistrationDuration: 'Duration',
  PlannedRegistrationQuantity: 'Quantity',
  PlannedRegistrationRemark: 'Remark',
  PlannedRegistrationAssignment: 'Assignment',
});

export default messages;
